var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMerchbarLogoWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 0C17.061 0 22 4.939 22 11C22 17.061 17.061 22 11 22C4.939 22 0 17.061 0 11C0 4.939 4.939 0 11 0ZM4.939 5.126H9.328L10.945 11.286H11.055C11.099 11.022 11.143 10.769 11.176 10.505C11.22 10.241 11.275 9.988 11.352 9.735L12.672 5.126H17.017L18.953 16.863H14.828L14.256 10.428H14.179C14.135 10.626 14.091 10.824 14.058 11.022C14.014 11.22 13.97 11.407 13.904 11.594L12.21 16.852H9.724L8.195 11.891C8.129 11.638 8.074 11.396 8.03 11.154C7.986 10.912 7.953 10.67 7.931 10.417H7.788C7.766 10.659 7.744 10.89 7.733 11.121C7.722 11.352 7.7 11.594 7.678 11.825L7.183 16.841H3.058L4.961 5.104L4.939 5.126Z",
    fill: "#00C8D5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMerchbarLogoWhite);
export default __webpack_public_path__ + "static/media/merchbar_logo_white.4c2ad956ec8f1cf9056a3cd66af3c9ad.svg";
export { ForwardRef as ReactComponent };